import { createApi } from "@reduxjs/toolkit/query/react";
import { data } from "src/@types/DATA";
import { btBaseQuery } from "src/Common/common";

// Define a service using a base URL and expected endpoints
export const datasApi = createApi({
	reducerPath: "datasApi",
	baseQuery: btBaseQuery,
	tagTypes: ["Data"],

	endpoints: (builder) => ({
		getDatas: builder.query<data[], void>({
			query: () => `data`,
			providesTags: ["Data"],
		}),
		getData: builder.query<data, number>({
			query: (id) => `data/data/${id}`,
			providesTags: ["Data"],
		}),
		insertData: builder.mutation({
			query: (data) => ({
				url: `/data/`,
				method: "POST",
				body: data,
			}),
			invalidatesTags: ["Data"],
		}),
		updateData: builder.mutation({
			query: (data) => ({
				url: `/data/`,
				method: "PUT",
				body: data,
			}),
			invalidatesTags: ["Data"],
		}),
		deleteData: builder.mutation({
			query: (data: data) => ({
				url: `/data/${data.ID}`,
				method: "DELETE",
				body: data,
			}),
			invalidatesTags: ["Data"],
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
	useGetDatasQuery,
	useGetDataQuery,
	useInsertDataMutation,
	useUpdateDataMutation,
	useDeleteDataMutation,
} = datasApi;
